var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('el-dialog', {
    attrs: {
      "visible": _setup.visible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": "package-limit-dialog",
      "width": "400px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _setup.visible = $event;
      }
    }
  }, [_c('section', {
    staticClass: "package-limit-dialog__content"
  }, [_c('button', {
    staticClass: "package-limit-dialog__close",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('common.Close')
    },
    on: {
      "click": _setup.closeDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _c('img', {
    staticClass: "package-limit-dialog__illustration",
    attrs: {
      "src": `${_setup.common.imageRoot}/marketingTools/package-limit.png`,
      "alt": ""
    }
  }), _c('h2', [_vm._v(_vm._s(_vm.$t('dashboard.Package-Limit-Dialog-Title')))]), _c('p', {
    staticClass: "package-limit-dialog__description"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.Package-Limit-Dialog-Content')))]), _c('div', {
    staticClass: "package-limit-dialog__actions"
  }, [_c('button', {
    staticClass: "package-limit-dialog__button package-limit-dialog__button--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _setup.goToSubscribe
    }
  }, [_vm._v(_vm._s(_vm.$t('dashboard.Package-Limit-Dialog-Subscribe')))]), _c('button', {
    staticClass: "package-limit-dialog__button package-limit-dialog__button--secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _setup.goToExpansionPack
    }
  }, [_vm._v(_vm._s(_vm.$t('dashboard.Package-Limit-Dialog-Expansion')))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };